
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class ChalkDrawingEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const shapes = Math.floor(12 * (config.parallaxComplexity || 1.0));
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * scale;

        const drawRawLine = (x1: number, y1: number, x2: number, y2: number) => {
             ctx.beginPath();
             ctx.moveTo(x1, y1);
             // Chalk grain simulation
             for (let i = 0; i < 10; i++) {
                 const t = i / 10;
                 const px = x1 + (x2 - x1) * t;
                 const noiseVal = (this.pseudoRandom(px + y1 + t) - 0.5) * 5 * scale;
                 const py = y1 + (y2 - y1) * t + noiseVal;
                 ctx.lineTo(px, py);
             }
             ctx.stroke();
        };

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.3 / (layerIndex + 1);
            for (let i = 0; i < shapes; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                const s = (50 + this.pseudoRandom(i + 2) * 100) * scale;
                
                // Draw a rough chalkboard box or circle
                if (this.pseudoRandom(i) > 0.5) {
                    drawRawLine(rx, ry, rx + s, ry);
                    drawRawLine(rx + s, ry, rx + s, ry + s);
                    drawRawLine(rx + s, ry + s, rx, ry + s);
                    drawRawLine(rx, ry + s, rx, ry);
                } else {
                    ctx.beginPath();
                    ctx.arc(rx, ry, s/2, 0, Math.PI * 2);
                    ctx.setLineDash([5, 5]);
                    ctx.stroke();
                    ctx.setLineDash([]);
                }
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
